import React from 'react';
import ParticiplesGame, { PARTICIPLES_GAME_CONFIGS } from './ParticiplesGame';

function ParticiplesGameII() {
  return <ParticiplesGame gameConfig={PARTICIPLES_GAME_CONFIGS.binyan2} />;
}

export default ParticiplesGameII;
